import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const LogoutDialog = ({ visible, onHide }) => {
	const footerContent = (
		<div>
			<Button label="OK" icon="pi pi-check" onClick={onHide} autoFocus />
		</div>
	);

	return (
		<Dialog header="Session Expired" visible={visible} style={{ width: "30vw" }} onHide={onHide} closable={false} footer={footerContent}>
			<p>Your session has expired. Please log in again to continue.</p>
		</Dialog>
	);
};

export default LogoutDialog;
